import React, { useEffect, useMemo } from 'react';
import styles from './UnitsView.module.scss';
import Spinner from 'src/components/spinner/Spinner';
import { ProgramFragment, Unit, useGetAusCourseContentsLazyQuery, useGetCourseContentsLazyQuery } from '../../../api/graphql-codegen';
import Card from './card/Card';
import Button from '@src/components/button/Button';
import { countryOptions } from '@src/constants';
import CoverContent from '@src/components/CoverContent/CoverContent';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';


type Props = {
  handleCancel?: () => void                     // cancel button action
  handleEditUnit: (unit: Unit) => void          
  course?: ProgramFragment                      // course
}

function UnitsView(props: Props) {
  const { handleCancel, handleEditUnit, course } = props;
  
  const [getAusCourseContents, {data: ausProgramData, loading}] = useGetAusCourseContentsLazyQuery({fetchPolicy: 'network-only'})
  const [getCourseContents, {data: programData, loading: loading1}] = useGetCourseContentsLazyQuery({fetchPolicy: 'network-only'})

  const isAusCourse = useMemo(() => course?.country === countryOptions[1].label, [course?.country])

  useEffect(() => {
    if (isAusCourse && course?.id) {
      getAusCourseContents({
        variables: {
          input: {
            id: course.id
          }
        }
      })
    }
  }, [isAusCourse, course, getAusCourseContents])

  useEffect(() => {
    if (!isAusCourse && course?.id) {
      getCourseContents({
        variables: {
          input: {
            id: course.id
          }
        }
      })
    }
  }, [isAusCourse, course, getCourseContents])

  const gradeContents = useMemo(() => [...programData?.getCourseContents?.primary || []], [programData?.getCourseContents?.primary]);
  const additionContents = useMemo(() => [...programData?.getCourseContents?.additional || []], [programData?.getCourseContents?.additional]);
  const gradeCourseContents = useMemo(() => [...ausProgramData?.getAUSCourseContents || []], [ausProgramData?.getAUSCourseContents])

  const topTitle = useMemo(() => {
    let title = `View Units${course?.name ? ` for ${course?.name}` : ''} for school`

    if (course?.name) {
      title = `View Units for ${course.name}`
    } 
    return title;
  }, [course])

  const gradeTitle = useMemo(() => {
    let title = "Grade 1";
    
    if (course?.name) {
      title = course.name;
    }
    return title;
  }, [course?.name]);
  
  return (
    <div className={styles.page}>
      {loading || loading1 ? <div className={styles.spinner}><Spinner /></div> : <>
        <div className={styles.header}>
          <Button className={styles.actionsBanner_cancel} onClick={handleCancel} size={'small'} label={'Back'} />
          <div className={styles.title}>{topTitle}</div>
        </div>
        {isAusCourse ? 
          <DndProvider backend={HTML5Backend}>
            <div className={styles.unitsDivWithFour}>
            {gradeCourseContents.map((content, index) => (
              <CoverContent
                key={index}
                type={"type"}
                content={content}
              />
            ))}
          </div>
        </DndProvider> : <>
        { gradeContents.length > 0 && <div className={styles.unitGroupTitle}>{gradeTitle}</div>}
        <div className={styles.unitsDiv}>
          {gradeContents.map((unit, index) => (
            <Card
              key={index}
              unit={unit}
              handleEditUnit={handleEditUnit}
              index={index}
              />
            )
          )}
        </div>
        {additionContents.length > 0 && <div className={styles.unitGroupTitle}>Additional Content</div>}
        <div className={styles.unitsDiv}>
          {additionContents.map((unit, index) => (
            <Card
              key={index}
              unit={unit}
              handleEditUnit={handleEditUnit}
              index={index}
              />
            )
          )}
        </div>
        </>}
      </>}
    </div>
  
  );
}

export default UnitsView;
